module.exports = __webpack_public_path__ + "img/avatar.5a5bebf.png";